module.exports = __webpack_public_path__ + "static/media/b1.2911b61d.png";